import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [booting, setBooting] = useState(true);

  const refresh = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setUser(false);
      setBooting(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_e) {
      setToken(null);
      setUser(false);
    } finally {
      setBooting(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async ({ email, password, name, phone, access_code }) => {
    const { data } = await api.post("/auth/register", { email, password, name, phone, access_code });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const registerMember = async ({ email, password, name, phone }) => {
    const { data } = await api.post("/auth/register-member", { email, password, name, phone });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const registerCoach = async ({ email, password, name, business_name, phone }) => {
    const { data } = await api.post("/auth/register-coach", { email, password, name, business_name, phone });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_e) {}
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, booting, login, register, registerMember, registerCoach, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth outside provider");
  return ctx;
}
